"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.mediumLargeCols = exports.smallCols = void 0;
var makeStyles_1 = require("../../../theme/makeStyles");
exports.smallCols = [0, 1, 2, 3, 4];
exports.mediumLargeCols = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12
];
var makeSmSpanStyles = function () {
    return exports.smallCols.reduce(function (res, item) {
        var isZero = item === 0;
        var colStyles = {
            display: isZero ? 'none' : 'block'
        };
        if (!isZero) {
            colStyles.gridColumnEnd = "span ".concat(item);
        }
        res["span-sm-".concat(item)] = colStyles;
        return res;
    }, {});
};
var makeMdSpanStyles = function (breakpoints) {
    return exports.mediumLargeCols.reduce(function (res, item) {
        var _a;
        var isZero = item === 0;
        var colStyles = {
            display: isZero ? 'none' : 'block'
        };
        if (!isZero) {
            colStyles.gridColumnEnd = "span ".concat(item);
        }
        res["span-md-".concat(item)] = (_a = {},
            _a["@media (min-width: ".concat(breakpoints.medium, "px)")] = colStyles,
            _a);
        return res;
    }, {});
};
var makeLgSpanStyles = function (breakpoints) {
    return exports.mediumLargeCols.reduce(function (res, item) {
        var _a;
        var isZero = item === 0;
        var colStyles = {
            display: isZero ? 'none' : 'block'
        };
        if (!isZero) {
            colStyles.gridColumnEnd = "span ".concat(item);
        }
        res["span-lg-".concat(item)] = (_a = {},
            _a["@media (min-width: ".concat(breakpoints.large, "px)")] = colStyles,
            _a);
        return res;
    }, {});
};
var makeSmPushStyles = function () {
    return exports.smallCols.reduce(function (res, item) {
        res["push-sm-".concat(item)] = {
            gridColumnStart: item === 0 ? 'auto' : (item + 1).toString()
        };
        return res;
    }, {});
};
var makeMdPushStyles = function (breakpoints) {
    return exports.mediumLargeCols.reduce(function (res, item) {
        var _a;
        res["push-md-".concat(item)] = (_a = {},
            _a["@media (min-width: ".concat(breakpoints.medium, "px)")] = {
                gridColumnStart: item === 0 ? 'auto' : (item + 1).toString()
            },
            _a);
        return res;
    }, {});
};
var makeLgPushStyles = function (breakpoints) {
    return exports.mediumLargeCols.reduce(function (res, item) {
        var _a;
        res["push-lg-".concat(item)] = (_a = {},
            _a["@media (min-width: ".concat(breakpoints.large, "px)")] = {
                gridColumnStart: item === 0 ? 'auto' : (item + 1).toString()
            },
            _a);
        return res;
    }, {});
};
exports.default = (0, makeStyles_1.makeStyles)(function (_a) {
    var breakpoints = _a.breakpoints;
    return (__assign(__assign(__assign(__assign(__assign(__assign({}, makeSmSpanStyles()), makeMdSpanStyles(breakpoints)), makeLgSpanStyles(breakpoints)), makeSmPushStyles()), makeMdPushStyles(breakpoints)), makeLgPushStyles(breakpoints)));
});
